// extracted by mini-css-extract-plugin
export var card = "_7g-0";
export var failedIcon = "_7g-4";
export var failedIconBadge = "_7g-3";
export var icon = "_7g-1";
export var successIcon = "_7g-2";